export default "__VITE_ASSET__d232481d__"